const esigning_setup_route_methods = {
  reset_template_setup_state() {
    this.template_form_assignments = {};
    this.template_entity_type_assignments = [];
    this.assigned_workflow_binding = null;
    this.selected_form_id = '';
    this.selected_workflow_id = '';
  },

  read_query_value(key) {
    return String(this.$route?.query?.[key] ?? '').trim();
  },

  sync_context_from_route() {
    this.template_id = this.read_query_value('template_id');
    this.template_name = this.read_query_value('template_name');
    this.template_type = this.read_query_value('template_type');
    this.template_bindings = this.read_query_value('bindings');
    this.route_template_entity_type_id = this.read_query_value('template_entity_type_id');
    this.route_workflow_id = this.read_query_value('workflow_id');

    const route_tab = this.read_query_value('setup_tab');
    const valid_tabs = new Set(this.setup_tabs.map((tab) => tab.key));
    this.setup_active_tab = valid_tabs.has(route_tab) ? route_tab : 'forms';
  },

  set_active_tab(tab_key) {
    const valid_tabs = new Set(this.setup_tabs.map((tab) => tab.key));
    this.setup_active_tab = valid_tabs.has(tab_key) ? tab_key : 'forms';
    const query = this.setup_active_tab === 'configure'
      ? this.setup_query
      : this.base_setup_query;

    this.$router.replace({
      name: 'EsigningSetup',
      query: {
        ...query,
        setup_tab: this.setup_active_tab,
      },
    });
  },
};

export default esigning_setup_route_methods;
